<template>
  <div class="">
    <discount-best-rate-card-top :logo="logo"></discount-best-rate-card-top>
    <div class="tc c999" v-if="cuDiscountRate.length==0">该银行今天尚未发布报价</div>
    <div v-else>
      <!-- <div class="tl mb10"><span class="f14 c999">更新时间：{{new Date().pattern('yyyy-MM-dd')}}</span></div> -->
      <table width="100%" cellpadding="0" cellspacing="0">
        <tr class="c666 hl30" style="background: #FFF5F5">
          <!-- <td class="bre3e8ee" :rowspan="2">票据类型</td> -->
          <td class="bFFD4D4 pr" :rowspan="2">
            <div class="rowspan_style">
              银行类型
            </div>
          </td>
          <td class="brFFD4D4 btFFD4D4 bbFFD4D4 pr" :rowspan="2">
            <div class="rowspan_style">
              {{cuDiscountRate[0].dueType === 'DUE_DATE' ? '到期日' : '到期天数'}}
            </div>
          </td>
          <td class="brFFD4D4 bbFFD4D4 btFFD4D4" :colspan="cuDiscountRate[0].arrayList ? cuDiscountRate[0].arrayList.length : 1">票面金额（万元）</td>
        </tr>

        <tr class="c666 hl30" style="background: #FFF5F5">
          <td class="brFFD4D4 bbFFD4D4" v-for="(item3, index3) in cuDiscountRate[0].arrayList">{{item3.ebillAmt}}</td>
        </tr>

        <tr class="hl40" v-for="(body, index3) in cuDiscountRate" :key="index3">
          <!-- <td class="bbe3e8ee bre3e8ee" :rowspan="body.draftTypeTotal" v-if="body.draftTypeTotal">{{formatDict(body.draftType, 'draftType')}}</td> -->
          <td class="bbccc brccc blccc c333 fb" :rowspan="body.acceptBankLevelTypeTotal" v-if="body.acceptBankLevelTypeTotal">{{getBankLevel(body.bankLevel)}}</td>
          <td class="bbccc brccc c666" v-html="body.dueDateShow"></td>
          <td class="bbe9e9e9 brccc c000 fb bank-rate" @mouseover="$parent.cuActiveBank = item3.bankCode" @mouseleave="$parent.cuActiveBank = ''" :style="setBankRateBgStyle(item3.bankCode)" v-for="(item3, index3) in body.arrayList" @click="tolink(item3)">
            <div class="pr">
              {{changeRate(item3.billRate)}}
              <span class="bank-name">{{item3.bankName}}</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import DiscountBestRateCardTop from './DiscountBestRateCardTop.vue';
export default {
  components: { DiscountBestRateCardTop },
  name: 'discountRateCard',
  props: ['cuDiscountRate', 'levelBankList', 'logo', 'bankName', 'type', 'cuActiveBank'],
  inject: ['DiscountRate'],
  methods: {
    // 利率
    changeRate (rate) {
      if (String(rate).indexOf('%') > -1) {
        return rate;
      } else if (rate) {
        let decimal = String(rate)
        // 最少保留两位小数，超出的不做四舍五入
        if (decimal.split('.')[1].length >= 4) {
          return Number(rate).mul(100) + '%';
        } else {
          return Number(rate).mul(100).toFixed('2') + '%';
        }
      } else {
        return '0.00%';
      }
    },
    // 承兑行
    acceptingBank (bankLevel) {
      if (this.type === 'fm') {
        // 富民自渠道
        if (this.levelBankList[bankLevel].length > 0) {
          return `${this.getBankLevel(bankLevel)}${this.levelBankList[bankLevel].length}个：${this.levelBankList[bankLevel] && this.levelBankList[bankLevel].join('、')}`
        }
      }
      // rzline配置
      if (this.levelBankList[bankLevel] && this.levelBankList[bankLevel].length === 1) {
        let length = this.levelBankList[bankLevel][0] ? this.levelBankList[bankLevel][0].split('、').length : 0
        if (length > 0) {
          return `${this.getBankLevel(bankLevel)}${length}个：${this.levelBankList[bankLevel] && this.levelBankList[bankLevel]}`
        }
      }

      return '';
    },
    // 几类行
    getBankLevel (bankLevel) {
      // 富民自渠道
      if (this.type === 'fm') {
        return this.formatDict(bankLevel, 'acceptorLevel')
      }
      // rzline配置
      return this.formatDict(bankLevel, 'acceptorLevel')
    },
    // 设置最优报价背景颜色
    setBankRateBgStyle (bankCode) {
      //  :style="`background-color:`+$store.state.publicData.bankColor[]"
      // if (this.cuActiveBank && bankCode === this.cuActiveBank) {
      //   return `background-color:#fff`
      // }
      return `background-color:${this.$store.state.publicData.bankColor[bankCode]}`
    },
    tolink (val) {
      this.DiscountRate.type = ''
      // this.DiscountRate.bankInfo = Object.assign({}, this.DiscountRate.bankInfo, {
      //   bankName: val.bankName,
      //   bankCode: val.bankCode
      // })
      this.DiscountRate.bankInfo.bankName = val.bankName;
      this.DiscountRate.bankInfo.bankCode = val.bankCode;
      // this.activeInfo.bankName = info.bankName;
      // this.activeInfo.logo = info.bankCode
      console.log(val, this.DiscountRate.bankInfo);
    }
  },
  mounted () {
    console.log('=============logo', this.logo, this.cuDiscountRate.bankInfo)
  }
}
</script>

<style lang="scss" scoped>
.fw500 {
  font-weight: 500;
}
.rowspan_style {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
table {
  background: url(~@/assets/img/discountTrends/LOGO.png) repeat center center;
  // background-size: cover;
}
.bbe9e9e9 {
  border-bottom: 1px solid #e9e9e9;
}
.bank-rate:hover {
  cursor: pointer;
  background-color: rgba(242, 248, 255, 0.5) !important;
  .bank-name {
    display: inline-block;
  }
}
.bank-name {
  display: none;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -14px;
  background-color: #fff5f5;
  border: 1px solid #ffd4d4;
  padding: 4px 9px;
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.3);
  color: #ac7979;
  border-radius: 4px;
}
.bank-name::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: -6px;
  border-left: 6px solid transparent;
  border-top: 6px solid #fff5f5;
  border-right: 6px solid transparent;
  transform: translateX(-50%);
}
</style>


// WEBPACK FOOTER //
// src/components/common/DiscountBestRateCard.vue